module.exports = __webpack_public_path__ + "author_default-fdacd4bce0ee1cfd7d09.svg";